import { BaseModel } from "sjs-base-model";
import A7CategoryModel from "./A7CategoryModel";
import A7ProductModel from "./A7ProductModel";

export default class A7ProductsModel extends BaseModel {
    categories = [A7CategoryModel];
    products = [A7ProductModel];

    constructor(data) {
        super();
        this.update(data);
    }
}
